import React from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import FormHandler from 'components/Form/FormHandler'
import BInput from 'components/Form/Fields/BInput'
import {buildiroBlogUrl} from 'components/Landing/LandingBlog'
import {StripeIcon} from 'components/CustomIcons'

const join = ({email}, setLoading) => {
  alert('Work in progress... send to backend: ' + email)
  setLoading(false)
}

const Footer = () => {
  const {t} = useTranslation()

  return (
    <footer id='footer'>
      <section>
        <div>
          <div>
            <h6>{t('OUR COMPANY')}</h6>

            <Link to='/about'>{t('About Buildiro')}</Link><br/>
            <a href={buildiroBlogUrl} target='_blank' rel="noopener noreferrer">{t('Our blog')}</a><br/>
            <Link to='/contact'>{t('Contact us')}</Link><br/>
          </div>

          <div>
            <h6>{t('FOR CUSTOMERS')}</h6>

            <Link to='/about'>{t('About Buildiro')}</Link><br/>
            <Link to='/about'>{t('About Buildiro')}</Link><br/>
            <Link to='/about'>{t('About Buildiro')}</Link><br/>
          </div>

          <div>
            <h6>{t('FOR MERCHANTS')}</h6>

            <Link to='/about'>{t('About Buildiro')}</Link><br/>
            <Link to='/about'>{t('About Buildiro')}</Link><br/>
            <Link to='/about'>{t('About Buildiro')}</Link><br/>
          </div>

          <div className='footer-newsletter'>
            <h6>{t('JOIN TO OUR NEWSLETTER')}</h6>

            <FormHandler submitTitle={t('JOIN')} submitCallback={join}>
              <BInput fieldName='email' email white placeholder={t('Your e-mail')}/>
            </FormHandler>
            <span>
              {t('By submitting the form you will accept our')} <Link to='/termsAndConditions'>
                {t('Terms & Conditions')}
              </Link>
            </span>
          </div>
        </div>
      </section>

      <section>
        <div className='group'>
          <div>
            <h6>{t('Secure shopping')}</h6>

            <StripeIcon/>
          </div>

          <div>
            <h6>{t('We are trusted seller')}</h6>

          </div>

          <div>
            <h6>&copy; {t('2020 Buildiro')}</h6>
          </div>
        </div>
      </section>
    </footer>
  )
}

export default Footer
